export default {"src":"/_next/static/media/members.dd0f27a1.svg","height":54,"width":65};